import { MEDIA, NUMERI } from "@/data/content";

export default function ChiSiamo() {
  return (
    <div data-testid="page-chi-siamo" className="pt-28">
      <section className="container-x py-16 sm:py-24 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Chi siamo</span>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight">
            Una società di <span className="italic text-primary">brokeraggio</span> nata per stare dalla parte del cliente.
          </h1>
        </div>
      </section>

      <section className="container-x grid md:grid-cols-12 gap-10 pb-20">
        <div className="md:col-span-7 order-2 md:order-1 space-y-6 text-lg leading-relaxed text-muted-foreground">
          <p>
            XL Brokers nasce a Bologna come società di brokeraggio assicurativo indipendente, con un'unica missione: offrire a PMI, professionisti e famiglie italiane la stessa qualità di consulenza che le grandi corporate hanno sempre dato per scontata.
          </p>
          <p>
            Lavoriamo come un piccolo atelier sartoriale: pochi clienti per consulente, tempi di risposta brevi, wording costruiti riga per riga. Nessuna policy standardizzata, nessuna pressione commerciale verso compagnie preferite.
          </p>
          <p>
            Il nostro team unisce competenze tecniche profonde nei rami specialistici — costruzioni, sanitaria, RC professionale, employee benefit — ad una visione moderna del rischio aziendale, che include cyber, reputazione e continuità operativa.
          </p>
        </div>
        <div className="md:col-span-5 order-1 md:order-2">
          <img src={MEDIA.about} alt="Stretta di mano" className="w-full aspect-[4/5] object-cover" />
        </div>
      </section>

      <section className="bg-[#0A1F2E] text-white section-y">
        <div className="container-x">
          <span className="overline text-[#89E877]">I nostri numeri</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl">Una crescita guidata dalla fiducia.</h2>
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6">
            {NUMERI.map((n) => (
              <div key={n.label}>
                <p className="font-display text-5xl sm:text-6xl text-[#89E877]">{n.kpi}</p>
                <p className="mt-3 text-xs uppercase tracking-[0.28em] text-white/55">{n.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x section-y grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <span className="overline">Approccio</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight">Il metodo XL.</h2>
        </div>
        <ol className="md:col-span-8 space-y-12">
          {[
            {
              t: "Ascolto",
              d: "Iniziamo dall'ascolto: del tuo business, dei tuoi numeri, dei tuoi timori. Senza presentazioni di prodotto.",
            },
            {
              t: "Analisi",
              d: "Mappiamo le esposizioni, valutiamo le coperture in essere, mettiamo nero su bianco i gap.",
            },
            {
              t: "Progetto",
              d: "Disegniamo un programma assicurativo coordinato — non una somma di polizze — e lo negoziamo sul mercato.",
            },
            {
              t: "Presidio",
              d: "Affianchiamo il cliente lungo tutto l'anno: rinnovi, sinistri, variazioni, audit periodici.",
            },
          ].map((s, i) => (
            <li key={s.t} className="grid grid-cols-12 gap-6 border-t border-foreground/10 pt-8">
              <span className="col-span-2 md:col-span-1 font-display text-3xl text-primary/40">0{i + 1}</span>
              <div className="col-span-10 md:col-span-11">
                <h3 className="font-display text-3xl">{s.t}</h3>
                <p className="mt-3 text-muted-foreground leading-relaxed max-w-2xl">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
